// Single source of truth for "where does this AI run point to?".
//
// Every AgentJob is tagged on the backend with a related object (see
// ai_agent/views.py and scheduler/tasks.py). Mapping that to an in-app route
// here keeps the AI activity pill and the run-history modal in sync, so every
// run the user sees is clickable and lands on the thing it worked on.

interface JobRef {
  related_object_type?: string | null;
  related_object_id?: string | null;
}

export function getJobUrl(job: JobRef): string | null {
  const { related_object_type: type, related_object_id: id } = job;
  if (!type || !id) return null;
  switch (type) {
    case 'content_outline':
      // Content + media runs both hang off the outline → the post detail view.
      return `/content/${id}`;
    case 'content_plan':
      return '/plans';
    case 'content_strategy':
      return '/strategy';
    case 'content_pillar':
      return '/pillars';
    case 'session':
      return '/assistant';
    default:
      return null;
  }
}
